import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voice-circle, waves"><path d="M3.19043 14.6428C12.4404 -1.65477 13.6066 23.798 20.8095 14.6428" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M3.80908 16.4049C9.4295 12.3567 12.7295 20.1411 17.7262 19.2732" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVoiceCircle;
